import "./index.scss";
import "../../App.scss";
import "../../index.scss";
import { Link } from "react-router-dom";
import { useLocationParams } from "../nonUIFuncs";

/**
 * Redirect page component that displays when users navigate to a non-existent route.
 * Shows a 404-style message and provides a button to return to the home page.
 *
 * @returns {JSX.Element} 404 page with home navigation button
 */
const RedirectPage = () => {
  return (
    <div className="redirect_container all_pages_container">
      <h1>This page does not exist</h1>
      <Link
        to={{ pathname: "/", search: useLocationParams("", []) }}
        className="redirect_button hovercursor"
      >
        <p className="redirect_buttontext">Click here to return Home</p>
      </Link>
    </div>
  );
};

export default RedirectPage;
